import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TiposDocumento } from './tipos-documento.model';

@Injectable({
  providedIn: 'root'
})
export class TiposDocumentoService {
  url: string;

  constructor(private http: HttpClient) {}

  getTiposDocumento(): Observable<TiposDocumento[]> {
    return this.http.get<TiposDocumento[]>(`${this.url}/tiposDocumento/`);
  }
}
